import { Typography, TypographyProps } from '@material-ui/core';
import React from 'react';

type Type = 'uppercase';

interface IProp {
  type?: Type;
}

export const Title: React.FC<IProp & TypographyProps> = ({ children, variant, type = '', ...rest }) => {
  const text = type === 'uppercase' ? String(children).toUpperCase() : children;

  return (
    <Typography variant={variant} {...rest}>
      {text}
    </Typography>
  );
};
